import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./features/global-state/globalStateSlice";
import userReducer from "./features/user/userSlice";
import orderReducer from "./features/orderState";
import usersReducer from "./features/users";
import storeReducer from "./features/storeMgmt/storeMgmtSlice";
import inventoryReducer from "./features/inventory/inventorySlice";
import maintenanceReducer from "./features/maintenance/maintenanceSlice";
import invoiceReducer from "./features/invoiceSlice/invoiceSlice";
import settingsReducer from "./features/setting/settingsSlice";

export default configureStore({
  reducer: {
    globalState: globalReducer,
    userState: userReducer,
    orderState: orderReducer,
    UsersState: usersReducer,
    StoreState: storeReducer,
    inventoryState: inventoryReducer,
    maintenanceState: maintenanceReducer,
    invoiceState: invoiceReducer,
    settingState: settingsReducer,
  },
});
